import React from "react";
import {css, Theme} from "@emotion/react";

import {WideContent} from "@pg-design/grid-module";
import {pr} from "@pg-design/helpers-css";

export interface IProps {
    children: React.ReactNode;
    className?: string;
}

export const OfferLocationLinksWrapper: React.FC<IProps> = (props) => {
    return (
        <div css={offerListLocationLinksPanelsBase} className={props.className}>
            <WideContent css={contentStyles}>{props.children}</WideContent>
        </div>
    );
};

export const OfferListLocationLinksWrapper: React.FC<IProps> = (props) => {
    return (
        <div css={[offerListLocationLinksPanelsBase, listingLocationLinksStyle]} className={props.className}>
            <WideContent css={contentStyles}>{props.children}</WideContent>
        </div>
    );
};

const listingLocationLinksStyle = (theme: Theme) => css`
    background-color: #fff;

    @media (min-width: ${theme.breakpoints.md}) {
        background-color: transparent;
    }
`;

const offerListLocationLinksPanelsBase = (theme: Theme) => css`
    width: 100%;
    margin: 0 auto;
    padding: 0;
    display: flex;
    flex-wrap: wrap;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;

        > div:not(:last-of-type) {
            ${pr()}
        }
    }

    @media (min-width: ${theme.breakpoints.sm}) and (max-width: ${theme.breakpoints.md}) {
        flex-direction: row;

        > div:nth-of-type(odd) {
            ${pr()}
        }
    }
`;

const contentStyles = (theme: Theme) => css`
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {WideContent} from "@pg-design/grid-module";
import {pr} from "@pg-design/helpers-css";

export interface IProps {
    children: React.ReactNode;
    className?: string;
}

export const OfferLocationLinksWrapper: React.FC<IProps> = (props) => {
    return (
        <div css={offerListLocationLinksPanelsBase} className={props.className}>
            <WideContent css={contentStyles}>{props.children}</WideContent>
        </div>
    );
};

export const OfferListLocationLinksWrapper: React.FC<IProps> = (props) => {
    return (
        <div css={[offerListLocationLinksPanelsBase, listingLocationLinksStyle]} className={props.className}>
            <WideContent css={contentStyles}>{props.children}</WideContent>
        </div>
    );
};

const listingLocationLinksStyle = (theme: Theme) => css`
    background-color: #fff;

    @media (min-width: ${theme.breakpoints.md}) {
        background-color: transparent;
    }
`;

const offerListLocationLinksPanelsBase = (theme: Theme) => css`
    width: 100%;
    margin: 0 auto;
    padding: 0;
    display: flex;
    flex-wrap: wrap;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;

        > div:not(:last-of-type) {
            ${pr()}
        }
    }

    @media (min-width: ${theme.breakpoints.sm}) and (max-width: ${theme.breakpoints.md}) {
        flex-direction: row;

        > div:nth-of-type(odd) {
            ${pr()}
        }
    }
`;

const contentStyles = (theme: Theme) => css`
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
    }
`;
